import type { GetStaticProps } from 'next';
import dynamic from 'next/dynamic';

// 루트('/play') 전용 dev 스페이스 진입 페이지.
// 프리뷰(웹앱 없이 play-app 단독)에서 mapHashId 없이 접근했을 때
// 바로 스페이스를 고르거나 URL 을 붙여넣어 진입할 수 있게 한다.
// prod/stage 는 getStaticProps 에서 notFound → 기존처럼 404.
const DevSpaceEntry = dynamic(() => import(/* webpackChunkName: "dev-space-entry" */'../components/DevSpaceEntry/DevSpaceEntry').then(m => ({
  default: m.DevSpaceEntry
})), {
  ssr: false
});
const IndexPage = () => {
  return <div style={{
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    background: '#0e0e13'
  }} data-sentry-component="IndexPage" data-sentry-source-file="index.tsx">
      <DevSpaceEntry variant="page" data-sentry-element="DevSpaceEntry" data-sentry-source-file="index.tsx" />
    </div>;
};
export const getStaticProps: GetStaticProps = async () => {
  const isDevEnv = process.env.NEXT_PUBLIC_STAGE !== 'PRD' && process.env.NEXT_PUBLIC_STAGE !== 'STG';
  if (!isDevEnv) {
    return {
      notFound: true
    };
  }
  return {
    props: {}
  };
};
export default IndexPage;